const transformMedicalHistory = ({ results = [] }) =>
  Array.isArray(results) && results[0]
    ? results.map(
        ({
          id,
          patientId,
          code,
          valueQuantity,
          recordedDate,
          updatedDate,
          updatedAt,
          status,
        } = {}) => ({
          id,
          patientId,
          code: code?.coding?.code,
          display: code?.coding?.display,
          value: valueQuantity?.value,
          diagnoseDate: recordedDate, // TODO: is this still needed
          lastUpdateBy: updatedDate ?? updatedAt,
          status,
          // NOTE this is a UI display value for "Medical history - patient reported" card
          statusValue: status === 'active' ? 'Yes' : 'No',
        }),
      )
    : [];

export default transformMedicalHistory;
